<template>
	<div>
		<div _flex="~ items-center" style="height: calc(100vh);" _w="100%">
			<div class="w-basis-1/2" _flex="~ row-reverse">
				<img :src="BannerImg" width="95%" />
			</div>
			<div _flex="1 ~ justify-center">
				<div _flex="~ col items-center justify-center"  style="zoom:0.8">
          <img :src="userInfo?.avatar?.url || 'https://file.xinhuomy.com/default.png'" width="154px" height="154px" _m="b-30px" _border="rounded-900px" />
          <div _text="30px bolder" _p="b-25px">{{ userInfo?.realname }}</div>
          <div _text="[#727272] 16px" _p="b-80px">上次登录的账号信息</div>
          <el-button type="primary" class="submit-btns" @click="lastAccount">一键登录</el-button>
          <div _p="18px"></div>
          <el-button class="submit-btns" @click="otherAccount">使用其他账号登录</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { loginPreOperation } from './utils'
const BannerImg = require('@/assets/test_client/LoginImg.png')
export default {
	data() {
		return {
			BannerImg,
      userInfo: {}
		}
	},

	methods: {
    otherAccount() {
      window.localStorage.removeItem('tokenInfo')
      window.localStorage.removeItem('accountInfo')
      window.localStorage.removeItem('vuex.saved')
      window.localStorage.removeItem('vuex.menu')
      window.localStorage.removeItem('passTip')
      this.$router.replace('/login')
    },
    async lastAccount() {
      this.$api.user.httpPost('oauth/token', {
        grant_type: 'refresh_token',
        client_id: '3',
        scope: '',
        from: 'web',
        client_secret: 'PrhZBfJOmywBmoCXttA4r7uh4kNwvsl5o0jTMHyO',
        refresh_token: JSON.parse(localStorage.getItem('tokenInfo')).refresh_token
      })
      .then(res => {
        localStorage.setItem('tokenInfo', JSON.stringify(res))
        loginPreOperation(this)
      })
      .catch(err => {
        this.$router.replace('/login')
      })
    }
	},

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('accountInfo'))
    const refresh_token = JSON.parse(localStorage.getItem('tokenInfo'))?.refresh_token // 没有刷新token，直接重定向到login页面
    if (!refresh_token) {
      this.$router.replace('/login')
    }
  },
}
</script>

<style scoped>
.submit-btns {
  letter-spacing: 7px;
  width: 449px;
  font-size: 20px;
  height: 53px;
  text-align: center;
  border-radius: 6px;
  font-weight: bold;
}
</style>
